import React, { useMemo, useState } from "react";

type TProps = {
  label?: string;
  value: string;
  className?: string;
  placeholder?: string;
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  onClick?: (e: React.MouseEvent<HTMLSelectElement>) => void;
  onMouseUp?: (e: React.MouseEvent<HTMLSelectElement>) => void;
  onKeyUp?: (e: React.KeyboardEvent<HTMLSelectElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLSelectElement>) => void;
  options: Array<{ value: string; label: string }>;
}

export default function Select({
  label,
  value,
  className,
  placeholder,
  disabled,
  onChange,
  onFocus,
  onClick,
  onMouseUp,
  onKeyUp,
  onBlur,
  options,
}: TProps) {
  const [isFocused, setIsFocused] = useState(false);

  const option = useMemo(() => {
    return options.find(opt => opt.value === value);
  }, [options, value]);

  const isExpanded = useMemo(() => {
    return isFocused && !!option;
  }, [isFocused, option]);

  const handleFocus = (e: React.FocusEvent<HTMLSelectElement>) => {
    setIsFocused(true);
    onFocus?.(e);
  }

  const handleBlur = (e: React.FocusEvent<HTMLSelectElement>) => {
    setIsFocused(false);
    onBlur?.(e);
  }

  return (
    <div className={`vitrine-template8__select ${isExpanded ? '--expanded' : ''} ${className}`}>
      <div className="vitrine-template8__select__wrapper">
        <label className={`vitrine-template8__select__label ${isExpanded ? '--expanded' : ''}`}>
          {label}
        </label>
        <select
          className={`vitrine-template8__select__field ${isExpanded ? '--expanded' : ''}`}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          onFocus={handleFocus}
          onClick={onClick}
          onMouseUp={onMouseUp}
          onKeyUp={onKeyUp}
          onBlur={handleBlur}
        >
          <option value="" disabled>
            {placeholder || ''}
          </option>
          {options.map(option => (
            <option key={option.value} value={option.value} selected={value === option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {option && (
          <span className="vitrine-template8__select__value">
            {option.label}
          </span>
        )}
        <div className="vitrine-template8__select__icon">
          <tgr-icon size="md" icon={!isFocused ? "expand-more" : "expand-less"} />
        </div>
      </div>
    </div>
  )
}